import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AdminSearchComponent } from './admin-search/admin-search.component';
import { LocationAdminComponent } from './location-admin/location-admin.component';
import { LocationGroupComponent } from './location-group/location-group.component';
import { UserAdminComponent } from './user-admin/user-admin.component';
import { DeviceAdminComponent } from './device-admin/device-admin.component';

const routes: Routes = [
  { path: 'user-admin', component: UserAdminComponent },
  { path: 'location-admin', component: LocationAdminComponent },
  { path: 'location-group', component: LocationGroupComponent },
  { path: 'admin-search', component: AdminSearchComponent },
  { path: 'device-admin', component: DeviceAdminComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AdminRoutingModule {}
